import { React, useEffect, useLayoutEffect, useState, useRef, useEffectEvent } from 'react'
import { Helmet } from "react-helmet-async";

import { SplitText } from 'gsap/SplitText';

import $ from 'jquery';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from "gsap";

gsap.registerPlugin();
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

import HomeHero from '../HomeHero'
import HomeWork from '../HomeWork'
import HomeAbout from '../HomeAbout'
import HomeProcess from '../HomeProcess';
import GClientLogos from '../GClientLogos';
import HomeMarqueeText from '../HomeMarqueeText';
import HomeServices from '../HomeServices';
import GC_CTA_1 from '../GC_CTA_1';
import GC_Testimonials from '../GC_Testimonials';
import GC_CTA_2 from '../GC_CTA_2';


const Home = () => {
  const sectionHomeRef = useRef(null);
  const sectionClientLogosRef = useRef(null);
  const sectionWorkRef = useRef(null);
  const sectionAboutRef = useRef(null);
  const sectionProcessRef = useRef(null);

  const featuredWidth = useRef(null);

  // const [processSteps, setProcessSteps] = useState(["Vision Alignment", "Discovery & Clarity", "Strategic Planning", "Build & Execution", "Review & Optimization", "Launch & Support"]);
  const [processSteps, setProcessSteps] = useState(["Discovery & Planning", "Build & Execution", "Review & Optimization", "Launch & Support"]);

  const [isServiceOpen, setIsServiceOpen] = useState(0);
  const [imageCount, setImageCount] = useState(0);
  let loadingIconPinneScale = window.innerWidth > 700 ? .5 : .2;
  let containerWidth = $('.container').width();



  // FEATURED WORK
  function getScrollAmountWork() {
    let sectionWorkWidth = sectionWorkRef.current.scrollWidth;
    return -(sectionWorkWidth - window.innerWidth + 48);
  }

  function initGSAPWork() {

    featuredWidth.current = getScrollAmountWork();
    $('#debug').html("its from init " + featuredWidth.current)
    const tlWork = gsap.timeline({
      scrollTrigger: {
        trigger: sectionWorkRef.current,
        pin: true,
        start: 'top 5%',
        end: () => `+=${featuredWidth.current * -1}`,
        scrub: .5,

        ease: "none",
        markers: false,
        onUpdate: (self) => {
          if (self.progress >= .4)
            $('.loading-icon').css("opacity", "0");
          else
            $('.loading-icon').css("opacity", "1");
        }
      }
    });

    tlWork.to(sectionWorkRef.current.querySelector('.work-wrapper'),
      {
        x: featuredWidth.current,
      }, 0);
  }

  // ABOUT

  const initGSAPAbout = () => {



    var tlSplitAbout = gsap.timeline(),
      SplitAbout = new SplitText(".about .heading", { type: "words,chars" }),
      chars = SplitAbout.chars; //an array of all the divs that wrap each character


    var tlAbout = gsap.timeline({
      scrollTrigger: {
        id: 'triggerAbout',
        trigger: '.about ',
        start: 'top 80%',
        end: 'bottom 80%',
        scrub: true,
        markers: false
      },

    });


    tlAbout.fromTo(
      '.about .heading *',
      { opacity: 0.6 },
      { opacity: 1, stagger: .05, duration: 1 },

    )
      .fromTo(
        '.about img',
        { scale: 0, opacity: 0, duration: 5 },
        { scale: 1, opacity: 1, duration: 2 },
        "-=2"
      )
      .fromTo(
        '.about .fs-30, .about .fs-24',
        { opacity: 0, x: 30, duration: 5 },
        { opacity: 1, x: 0, stagger: 2, duration: 5 },
        "-=3"
      );

  }

  // PROCESS
  function initGSAPProcess() {

    let totalPlanets = processSteps.length - 1;
    let planetArr = Array.from({ length: totalPlanets }, (_, i) => i * 360 / totalPlanets);

    function degreeToRadian(radians) {
      return radians * (Math.PI / 180);
    }
    function getScrollAmountProcess() {
      return -(2000);
    }

    const tlProcessInit = gsap.timeline({
      scrollTrigger: {
        trigger: sectionProcessRef.current,
        pin: false,
        start: 'top 90%',
        end: "top 5%",

        scrub: 1,
        ease: 'none',
        markers: false,

        onUpdate: (self) => {
          $('.planet').each(function () {
            $(this).css("opacity", 1);
          });



          $('#galaxyPath').css("stroke-dashoffset", (-2100 * self.progress - 2100));
          let r = (Math.floor($('.solar-system').width() - 12) / 2);

          for (let i = 0; i < planetArr.length; i++) {
            let degF = -90 + (planetArr[i] * self.progress);
            let degFPer = degreeToRadian(degF);
            $('.planet-' + (i + 1)).css("left", (Math.cos(degFPer) * (r)) + (r - 4) + "px");
            $('.planet-' + (i + 1)).css("top", (Math.sin(degFPer) * (r)) + (r - 4) + "px");
          }

        }

      },
    });

    const tlProcess = gsap.timeline({
      scrollTrigger: {
        trigger: sectionProcessRef.current,
        pin: true,
        start: 'top 5.2%',

        end: () => `+=${getScrollAmountProcess() * -1}`,
        scrub: 1,
        ease: 'none',
        markers: false,

        onUpdate: (self) => {
          let progress = self.progress

          $('#galaxyPathActive').css("stroke-dashoffset", (-2100 * progress - 2100));

          let diff = 1 / planetArr.length;
          for (let i = 0; i < planetArr.length + 1; i++) {
            $('.planet-' + (i + 1)).removeClass('active');


            if (progress >= (diff * i) - .01) {



              $('.solar-system .heading').addClass("active");
              $('.solar-system .content').css("transform", "translateY(" + (- 1.11 * i) + "em)");
              $('.planet-' + (i + 1)).addClass('active');
            }

            if (progress == 0) {
              $('.planet-1').removeClass('active')
              $('.solar-system .heading').removeClass("active");
              $('.solar-system .content').css("transform", "translateY(1.1em)");
            }
          }

          // if (progress > 0)
          // {
          //   $('.solar-system .heading').addClass("active");
          //   $('.solar-system .content').css("transform", "translateY(-0.1em)");
          //   $('.planet-1').addClass('active');
          // }
          // else 
          // {
          //   $('.planet-1').removeClass('active');

          //   $('.solar-system .content').css("transform", "translateY(1.1em)");
          //   $('.solar-system .heading').removeClass("active");
          // }

          // if (progress > .19)
          // {
          //   $('.planet-2').addClass('active');
          //   $('.solar-system .content').css("transform", "translateY(-1.2em)");
          // }
          // else 
          //   $('.planet-2').removeClass('active');

          // if (progress > .39)
          // {
          //   $('.solar-system .content').css("transform", "translateY(-2.3em)");
          //   $('.planet-3').addClass('active');
          // }
          // else 
          //   $('.planet-3').removeClass('active');

          // if (progress > .59)
          // {
          //   $('.solar-system .content').css("transform", "translateY(-3.4em)");
          //   $('.planet-4').addClass('active');
          // }
          // else 
          //   $('.planet-4').removeClass('active');

          // if (progress > .79)
          // {
          //   $('.solar-system .content').css("transform", "translateY(-4.5em)");
          //   $('.planet-5').addClass('active');
          // }
          // else 
          //   $('.planet-5').removeClass('active');

          // if (progress > .97)
          // {
          //   $('.solar-system .content').css("transform", "translateY(-5.6em)");
          // }
        }
      },
    }, [imageCount]);
  }

  // Marquee Text
  function initGSAPMarquee() {
    const tlMarqueeTextBg = gsap.timeline({
      scrollTrigger: {
        trigger: 'section.home-marquee-text',
        start: 'top 90% ',
        end: 'bottom 80%',
        scrub: 1,
        markers: false
      },

    });
    tlMarqueeTextBg.fromTo('section.home-marquee-text',
      {
        width: 0,
      },
      {
        width: "100%",

      })


    const tlMarqueeText = gsap.timeline({
      scrollTrigger: {
        trigger: 'section.home-marquee-text ',
        start: 'top 100%',
        end: 'bottom 10%',
        scrub: 1,
        markers: false
      },

    });



    tlMarqueeText.fromTo(
      'section.home-marquee-text .marquee-wrapper',
      { x: window.innerWidth },
      {
        x: () => {
          let wrapperWidth = $('section.home-marquee-text .marquee-wrapper').width() - containerWidth;
          let spacing = (window.innerWidth - containerWidth)
          return (-wrapperWidth + spacing)
        }
      },

    )
  }

  // Services
  function initGSAPServices() {

    // const servicesObj = document.querySelectorAll('section.home-services .accordion-item');
    const servicesObj = document.querySelectorAll('section.home-services');

    gsap.fromTo('.home-services .hh1',
      {
        y: "100%",
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,

        scrollTrigger: {
          trigger: '.home-services .hh1',
          start: 'top 100%',
          end: 'bottom 80%',
          scrub: 'none',
          markers: false,

        },
      }
    )

    // for (const item of servicesObj)
    // {
    //   const tl = gsap.fromTo(item,
    //   {
    //       y: -20,
    //       x: "100%",
    //       opacity: 0,
    //       ease: 'none',
    //   },
    //   {
    //       y: 0,
    //       x: 0,
    //       opacity: 1,

    //       scrollTrigger: {
    //       trigger: item,
    //       start: 'top 90%',
    //       end: 'bottom 90%',
    //       scrub: 'none',
    //       markers: false,

    //   },
    //   })
    // }







    const tlServices = gsap.timeline({
      scrollTrigger: {
        trigger: 'section.home-services ',
        start: 'top 90%',
        end: 'bottom 100%',
        scrub: 'none',
        markers: false,
        ease: 'none',
      },
    });

    tlServices.fromTo(' section.home-services .accordion-item',
      {
        y: 300,
        x: "100%",

        opacity: 0,
      },
      {

        y: 0,
        x: 0,

        ease: 'none',
        opacity: 1,
        stagger: 1
      });

  }

  // CTA-1
  function initGSAPCTA_1() {

    const tlCTA1 = gsap.timeline({
      scrollTrigger: {
        trigger: 'section.cta-1 ',
        start: 'top 70%',
        end: 'bottom 90%',
        scrub: 2,
        markers: false,
        ease: 'none',
      },
    });



    tlCTA1.fromTo('section.cta-1 .hh1, section.cta-1 p, section.cta-1 button',
      {
        y: 300,


        opacity: 0,
      },
      {
        y: 0,


        opacity: 1,
        stagger: .1
      });

  }


  // testimonial
  function initGSAPTestimonials() {

    // TIMELINE FOR PIN CONTAINER 
    let tlTestimonialPin = gsap.timeline(
      {
        scrollTrigger: {
          trigger: 'section.testimonials',
          pin: true,
          start: 'top top',

          end: () => `+=${-2500 * -1}`,
          scrub: 1,
          ease: 'none',
          markers: false,


          onUpdate: (self) => {


          }
        },
      });

    // TIMELINE FOR HEADINGS 
    let tlTestimonialHeading = gsap.timeline(
      {
        scrollTrigger: {
          trigger: 'section.testimonials .heading-wrapper ',
          pin: false,
          start: 'top bottom',
          end: 'bottom 60%',
          scrub: 1,
          ease: 'none',
          markers: false,
        },
      });
    tlTestimonialHeading.fromTo('.heading-wrapper .hh3',
      {
        x: "50%",
        opacity: 0
      },
      {
        x: 0,
        opacity: 1
      });
    tlTestimonialHeading.fromTo('.heading-wrapper p',
      {
        x: "-50%",
        opacity: 0
      },
      {
        x: 0,
        opacity: 1
      }, .3);




    // TIMELINE FOR ROTATION
    let tlTestimonialContent = gsap.timeline(
      {
        scrollTrigger: {
          trigger: 'section.testimonials',
          pin: false,
          start: 'top bottom',

          end: () => `+=${(-10000) * -1}`,
          scrub: 1,
          ease: 'none',
          markers: false,


          onUpdate: (self) => {
            let progress = self.progress;
            let myBox3d = document.getElementsByClassName('item');
            for (let i = 0; i < myBox3d.length; i++) {
              let deg = -150 + (progress * 2) * (720) - (i * 72);
              myBox3d[i].style.transform = "rotateY(" + deg + "deg) translate3d(0px,0px,350px)";
            }
          }
        },
      });

    // TIMELINE FOR SLIDE IN 
    let tlTestimonialSlideIn = gsap.timeline(
      {
        scrollTrigger: {
          trigger: 'section.testimonials',
          pin: false,
          // start: 'top 70%',
          start: 'top 90%',

          end: () => `+=${(-5000 * .5) * -1}`,
          scrub: 1,
          ease: 'none',
          markers: false,
        }
      });
    tlTestimonialSlideIn.fromTo('section.testimonials .item',
      {
        left: () => { return (- $('section.testimonials .item').width() - window.innerWidth * .7) },
        top: "250%",
        // opacity: 0,
      },
      {

        left: () => { return (- $('section.testimonials .item').width() / 4) },
        top: "10dvh",
        // opacity: 1,


        ease: 'none',
        stagger: .5
      });

    // TIMELINE FOR SLIDE OUT 
    let tlTestimonialSlideOut = gsap.timeline(
      {
        scrollTrigger: {
          trigger: 'section.cta-1',
          pin: false,
          start: "top -260%",

          end: () => `+=${4000}`,
          scrub: 1,
          ease: 'none',
          markers: false,
        }
      });
    tlTestimonialSlideOut.to('section.testimonials .item',
      {

        left: () => { return ($('section.testimonials .item').width() * 14) },
        top: "-600%",
        // opacity: 0,


        ease: 'none',
        stagger: .03
      });
  }

  // TIMELINE CTA-2
  function initGSAPCTA_2() {
    const tlCTA2 = gsap.timeline(
      {
        scrollTrigger: {
          trigger: 'section.cta-2',
          pin: false,
          start: 'top 80%',

          end: 'bottom 80%',
          scrub: 1,
          ease: 'none',
          markers: false,
        }
      });

    tlCTA2.fromTo('section.cta-2 .fs-100, section.cta-2 .magnetic, section.cta-2 .hh4, section.cta-2 .fs-24, section.cta-2 .button-wrapper',
      {
        x: 300,
        opacity: 0

      },
      {
        x: 0,
        opacity: 1,
        stagger: .1,
      });
  }


  function initGSAPProjectCount() {

    var tlSplitAbout = gsap.timeline(),
      SplitAbout = new SplitText(".projects .heading", { type: "words,chars" }),
      chars = SplitAbout.chars; //an array of all the divs that wrap each character

    var tlSplitAboutText = gsap.timeline(),
      SplitAboutText = new SplitText(".projects .about-text", { type: "words" }),
      charsText = SplitAbout.chars; //an array of all the divs that wrap each character




    gsap.fromTo('.projects .heading *',
      {
        opacity: .5,
      },
      {
        opacity: 1,
        y: 0,
        duration: 2,
        stagger: .05,
        scrollTrigger: {
          trigger: ".projects .heading ",
          start: "top 80%",
          end: "bottom 70%",
          scrub: true,
          markers: false, // remove in production
        }
      });
    gsap.fromTo('.projects h2 *',
      {
        opacity: .5,
      },
      {
        opacity: 1,
        y: 0,
        duration: 2,
        stagger: .1,
        scrollTrigger: {
          trigger: ".projects h2",
          start: "top 70%",
          end: "bottom 70%",
          scrub: true,
          markers: false, // remove in production
        }
      });

    gsap.fromTo('.projects .fact',
      {
        opacity: 0,
        y: 100
      },
      {
        opacity: 1,
        y: 0,

        stagger: .1,
        scrollTrigger: {
          trigger: ".projects .fact-wrapper ",
          start: "top 80%",
          end: "bottom 60%",
          scrub: true,
          markers: false, // remove in production
        }
      });


  }



  // Scroll Trigger For WORK Section
  useLayoutEffect(() => {

    console.log("Main Layout")
    // LOGO GSAP
    {
      const tlLogoShift = gsap.timeline({
        scrollTrigger: {
          trigger: 'section.hero',
          pin: false,
          start: 'top top',
          end: 'bottom -50%',
          scrub: .5,
          ease: 'none',
          markers: false,

          onUpdate: (self) => {
            $('.loading-icon circle').css("opacity", 1 - (self.progress.toFixed(2) * 1.25));
            if (self.progress > 0.75)
              $('.loading-icon text').css("transform", "translateY(-200px)");
            else
              $('.loading-icon text').css("transform", "translateY(0px)");
          }
        },

      });


      tlLogoShift.to(".loading-icon",
        {
          top: "50%",
          translateX: "-50%",
          scale: loadingIconPinneScale

        }, 0);

      tlLogoShift.to('section.hero .container',
        {
          scale: 1.75,
          y: "-50%",
          opacity: 0
        }, 0);

      tlLogoShift.to('section.clientLogo',
        {
          scale: 1.75,
          opacity: 0,
          duration: .3,
          y: "400%"

        }, 0);
    }



    document.fonts.ready.then(() => {

      initGSAPWork();
      initGSAPProjectCount();
      initGSAPServices();
      initGSAPMarquee();

      initGSAPAbout();
      initGSAPProcess();

      initGSAPCTA_1();
      initGSAPTestimonials();
      initGSAPCTA_2();
    })








    return () => {
      ScrollTrigger.killAll();
    };

  }, [imageCount]);


  // // ONLY FOR TESTIMONIAL
  // useLayoutEffect(()=>
  // {

  //   const ctx = gsap.context(() =>
  //   {
  //     initGSAPMarquee();


  //     initGSAPAbout();

  //     

  //     


  //     




  //   })



  //    return () => {
  //    ctx.revert(); 


  //   };

  // },[isServiceOpen, imageCount])







  return (
    <>

      <Helmet>
        <link rel="canonical" href="https://robustik.com/" />
      </Helmet>


      <HomeHero ref={sectionHomeRef} />
      <GClientLogos ref={sectionClientLogosRef} widthVal={featuredWidth.current} />


      <HomeWork ref={sectionWorkRef} setImageCount={setImageCount} />

      <section className="projects pt-0">
        <div className='container'>
          <div className='xl:w-2/3 2xl:w-2/3'>
            <h1 className='hh1 heading font-medium' >Solving global challenges. Delivering digital impact.</h1>
          </div>

          <h2 className="xl:w-3/4 fs-24 opacity-70 about-text mt-6">With over 15 years of industry experience, we specialize in delivering tailored digital and technology-driven solutions that drive measurable success for businesses across diverse sectors, including finance, technology, operations, and enterprise services. Our approach is rooted in understanding each client’s unique challenges, goals, and market dynamics, enabling us to craft strategies and solutions that create real, lasting impact.</h2>

          <div className="flex flex-wrap mt-20 -mx-5 fact-wrapper">


            <div className='px-5 w-1/2 sm:w-1/2 lg:w-1/4 mb-8 fact'>
              <div className='hh2 font-light'>15+</div>
              <p className='m-0 fs-16 opacity-70'>Years of industry<br />experience</p>
            </div>
            <div className='px-5 w-1/2 sm:w-1/2 lg:w-1/4 mb-8 fact' >
              <div className='hh2 font-light'>100+</div>
              <p className='m-0 fs-16 opacity-70'>Successful Projects<br />Completed Globally</p>
            </div>
            <div className='px-5 w-1/2 sm:w-1/2 lg:w-1/4 mb-8 fact'  >
              <div className='hh2 font-light'>20+</div>
              <p className='m-0 fs-16 opacity-70 '>We’ve partnered with <br />more than 20 companies</p>
            </div>
            <div className='px-5 w-1/2 sm:w-1/2 lg:w-1/4 mb-8 fact'>
              <div className='hh2 font-light'>400+</div>
              <p className='m-0 fs-16 opacity-70'>Clients across <br />multiple industries</p>
            </div>
          </div>
        </div>
      </section>


      <HomeServices isServiceOpen={isServiceOpen} setIsServiceOpen={setIsServiceOpen} setImageCount={setImageCount} />
      <HomeMarqueeText />
      <HomeAbout setImageCount={setImageCount} id="about" />
      <HomeProcess ref={sectionProcessRef} processSteps={processSteps} />



      <GC_CTA_1 />
      <GC_Testimonials />
      <GC_CTA_2 />




    </>
  )
}

export default Home
